import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ResourceRequester } from "sulu-admin-bundle/services";
import Pagination from "sulu-admin-bundle/components/Pagination";
import Loader from "sulu-admin-bundle/components/Loader";
import AssociationView from "./AssociationView";
import ClubView from "./ClubView";
import styles from "./passport-statistics-page.module.scss";

const DEFAULT_LIMIT = 50;

const currentYear = new Date().getFullYear();
const YEAR_OPTIONS = Array.from({ length: 10 }, (_, i) => currentYear - i);

const PassportStatisticsPage = (props) => {
    const { t } = useTranslation();
    const router = props.router;
    const resourceId = router?.attributes?.id;
    const locale = router?.attributes?.locale || "de";

    const [query, setQuery] = useState({
        year: currentYear,
        page: 1,
        limit: DEFAULT_LIMIT,
    });
    const [request, setRequest] = useState({
        data: props.data || {},
        loading: false,
        error: false,
    });
    const { year, page, limit } = query;
    const { data, loading, error } = request;

    useEffect(() => {
        if (!resourceId) return;

        setRequest((prev) => ({ ...prev, loading: true, error: false }));

        const req = ResourceRequester.get("passport_statistics", {
            id: resourceId,
            year,
            locale,
            page,
            limit,
        });

        req.then((json) => setRequest({ data: json, loading: false, error: false }))
            .catch((err) => {
                if (err?.name === "AbortError") return;
                console.error("Failed to load passport statistics", err);
                setRequest((prev) => ({ ...prev, loading: false, error: true }));
            });

        return () => req.abort();
    }, [resourceId, year, locale, page, limit]);

    const handleYearChange = (newYear) =>
        setQuery((q) => ({ ...q, year: newYear, page: 1 }));

    const handleLimitChange = (newLimit) =>
        setQuery((q) => ({ ...q, limit: newLimit, page: 1 }));

    const handlePageChange = (newPage) =>
        setQuery((q) => ({ ...q, page: newPage }));

    const totalPages = data.perPage
        ? Math.ceil((data.totalPassports || 0) / data.perPage)
        : 1;

    return (
        <div>
            <div className={styles.yearSelector}>
                <label>{t("dhb.passport_statistics.year")}:</label>
                <select
                    value={year}
                    onChange={(e) => handleYearChange(Number(e.target.value))}
                >
                    {YEAR_OPTIONS.map((y) => (
                        <option key={y} value={y}>
                            {y}
                        </option>
                    ))}
                </select>
            </div>

            {loading && <Loader />}

            {!loading && error && (
                <p>{t("dhb.passport_statistics.load_error")}</p>
            )}

            {!loading && !error && data.type === "association" && (
                <AssociationView data={data} t={t} />
            )}
            {!loading && !error && data.type === "club" && (
                <Pagination
                    currentLimit={limit}
                    currentPage={page}
                    onLimitChange={handleLimitChange}
                    onPageChange={handlePageChange}
                    totalPages={totalPages}
                >
                    <ClubView data={data} t={t} />
                </Pagination>
            )}
        </div>
    );
};

export default PassportStatisticsPage;
